import { render, staticRenderFns } from "./HumanFace.vue?vue&type=template&id=bb2449ac&"
import script from "./HumanFace.vue?vue&type=script&lang=js&"
export * from "./HumanFace.vue?vue&type=script&lang=js&"
import style0 from "./HumanFace.vue?vue&type=style&index=0&id=bb2449ac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports